<template>
  <v-container id="about">

    <v-row justify="center" class="mt-5">
      <v-col cols="12" class="top-banner">
        <div class="content">
          <div class="tw-prose-sm tw-prose tw-max-w-none">
            <div class="tw-flex tw-justify-center lg:tw-justify-start">
              <h1 class="tw-border-r tw-border-black tw-pr-3 tw-mr-3 tw-text-lg md:tw-text-3xl">ภาษีเจริญ</h1>
              <span class="tw-text-lg md:tw-text-3xl">ทำการค้าให้เป็นเรื่องง่าย</span>
            </div>
            <h2 class="tw-my-1">e-Tax ครบจบในที่เดียวสำหรับ นักธุรกิจรุ่นใหม่</h2>
            <p>ภาษีเจริญช่วยให้คุณทำ e-Tax Invoice ส่งให้ลูกค้าได้ง่ายๆ แค่ปลายนิ้ว เหมาะสำหรับ : ทุกบริษัทที่ต้องการออกใบ e-Tax </p>
            <!-- <div class="tw-pb-5">
              <form action="/register" class="tw-flex tw-justify-center lg:tw-justify-start">
                <input type="text" placeholder="กรอกอีเมลเพื่อรับสิทธิ์ทดลองใช้งานฟรี" name="email"
                       class="tw-border tw-border-solid tw-border-gray-500 tw-rounded-l-md tw-w-80 tw-pl-6">
                <button class="tw-bg-light-green tw-text-white tw-py-2 tw-px-4 tw-rounded-r-md" type="submit">เริ่มต้นใช้งานฟรี</button>
              </form>
            </div> -->
          </div>
        </div>
        <div class="banner">
          <img src="/images/banners/home-accounting.jpg" alt="ภาษีเจริญ">
        </div>
      </v-col>

      <v-col cols="12">
        <img src="/images/banners/psc_diagram.png" alt="ขั้นตอนการทำงานของระบบ" style="width: 100%">
      </v-col>

    </v-row>

    <v-row justify="center" class="mt-1">
      <v-col md="12">
        <div class="about-slide d-none d-sm-flex">

          <div class="box-wrapper">
            <div class="box">
              <h1 class="tw-font-bold">100%</h1>
              <p>ความถูกต้องของเอกสาร</p>
            </div>
          </div>

          <div class="box-wrapper">
            <div class="box">
              <h1 class="tw-font-bold">25-50 เท่า</h1>
              <p>ดึงข้อมูลเร็วกว่าคีย์เองให้เร็วขึ้น</p>
            </div>
          </div>

          <div class="box-wrapper">
            <div class="box">
              <h1 class="tw-font-bold">200,000</h1>
              <p>ประหยัดเงินไปได้ขั้นต่ำ 2 แสนบาทต่อปี</p>
            </div>
          </div>

          <div class="box-wrapper">
            <div class="box">
              <h1 class="tw-font-bold">10 ปี</h1>
              <p>เก็บรักษาข้อมูลระบบ cloud</p>
            </div>
          </div>

        </div>

        <div class="slide-wrapper d-sm-none">
          <VueSlickCarousel
            :centerMode="true"
            :slidesToShow="1"
            :slidesToScroll="1"
            :arrows="true"
            :dots="true"
            style="margin-bottom: 20px; margin-top: 20px; height: 250px;">
            <div class="about-slide mobile">
              <div class="box-wrapper">
                <div class="box">
                  <h1>100%</h1>
                  <p>ความถูกต้องของเอกสาร</p>
                </div>
              </div>
            </div>
            <div class="about-slide mobile">
              <div class="box-wrapper">
                <div class="box">
                  <h1>60 เท่า</h1>
                  <p>ดึงข้อมูลเร็วกว่าคีย์เองให้เร็วขึ้น</p>
                </div>
              </div>
            </div>
            <div class="about-slide mobile">
              <div class="box-wrapper">
                <div class="box">
                  <h1>200,000</h1>
                  <p>ประหยัดเงินไปได้ขั้นต่ำ 2 แสนบาทต่อปี</p>
                </div>
              </div>
            </div>
            <div class="about-slide mobile">
              <div class="box-wrapper">
                <div class="box">
                  <h1>2 เท่า</h1>
                  <p>ดึงข้อมูลเร็วกว่าคีย์เองให้เร็วขึ้น</p>
                </div>
              </div>
            </div>

          </VueSlickCarousel>
        </div>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'About',
  components: {
    VueSlickCarousel
  }
}
</script>

<style lang="scss">
#about {
  overflow: hidden;

  .top-banner {
    display: flex;

    .content {
      padding: 4% 3%;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      background-color: #ffffff;
      border-top-right-radius: 100px;
      border-bottom-left-radius: 100px;
      height: 90%;
      margin-top: 2%;
      margin-right: -5%;
      z-index: 10;

      h1 {
        margin-bottom: 20px;
        font-size: 30px;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .top-banner {
      display: block;

      img {
        width: 100%;
      }

      .content {
        margin: 0;
        padding: 0;
        box-shadow: none;
        text-align: center;
        height: auto;
      }
    }
  }

  .about-slide {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .box-wrapper {
      display: flex;
      width: 24%;
      margin-bottom: 2%;
      align-items: stretch;

      .box {
        text-align: center;
        padding: 20px 15px 10px;
        border-radius: 20px;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        background-color: #ffffff;
        position: relative;
        overflow: hidden;
        width: 100%;

        h1 {
          color: #6ec39b;
          font-size: 40px;
        }

        h2 {
          font-size: 16px;
          background: #6ec39b;
          margin: 0;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding-top: 20px;
          padding-bottom: 20px;
          color: #FFFFFF;
        }

        p {
          line-height: 30px;
          padding: 0 20px;
        }
      }

      &:nth-child(2) {
        .box {
          //background: #619fd4;

          h1, p {
            //color: #FFFFFF;
          }
        }
      }
    }

    .slide-wrapper {
      overflow: hidden;
      background: green;
    }

    &.mobile {
      width: 90% !important;
      margin-left: -10%;

      .box-wrapper {
        display: inline-block;

        .box {
          height: 200px;
        }
      }

      .blue {
        color: #FFFFFF;
        background: #619fd4;

        h1 {
          color: #FFFFFF;
        }
      }
    }

    @media only screen and (max-width: 768px) {
      & {
        .box-wrapper {
          width: 49%;
        }
      }
    }

    @media only screen and (max-width: 767px) {
      & {
        .box-wrapper {
          width: 100% !important;
        }
      }
    }
  }

  *:focus {
    outline: none !important;
  }
}

</style>
